// Teams call links in Microsoft Teams chats (Kjuup-BE POST /teams/chats/:groupId/call). The call
// buttons of a Teams chat create a Teams meeting and send its join link into the chat as a normal
// text message; every message with a Teams meeting link shows a "Join now" card. Pure helpers;
// the mobile app's utils/teamsCall.js is the same.

// Classic meeting links (/l/meetup-join/), the short ones (/meet/<id>?p=…) and Teams free.
const MEETING_URL_RE = /https:\/\/teams\.(?:microsoft|live)\.com\/(?:l\/meetup-join|meet)\/[^\s<>()[\]"']+/i;

// The message the call buttons send: "📞 **Teams call** · [Join now](<url>)".
const CALL_MESSAGE_RE = /^\s*(📞|🎥)\s*\*\*[^*\n]+\*\*\s*·\s*\[[^\]\n]+\]\((\S+)\)\s*$/u;

const tr = (strings, key, fallback) => (strings && strings[key]) || fallback;

/** The first Teams meeting link in `text`, or null. */
export function teamsMeetingUrlOf(text) {
  const m = typeof text === "string" ? text.match(MEETING_URL_RE) : null;
  return m ? m[0] : null;
}

/**
 * What the chat bubble shows for a message with a Teams meeting link, or null:
 *   { url, kind: 'audio' | 'video' | 'meeting', rest }
 * kind 'audio' / 'video' = sent by the call buttons (rest ''); 'meeting' = any other text with a
 * meeting link (rest = that text, shown above the button).
 */
export function teamsCallOf(text) {
  if (typeof text !== "string" || !text) return null;
  const sent = text.match(CALL_MESSAGE_RE);
  if (sent && teamsMeetingUrlOf(sent[2]) === sent[2]) {
    return { url: sent[2], kind: sent[1] === "🎥" ? "video" : "audio", rest: "" };
  }
  const url = teamsMeetingUrlOf(text);
  return url ? { url, kind: "meeting", rest: text.trim() } : null;
}

/** The text the call buttons send into the chat (Markdown; Teams gets a link "Join now"). */
export function teamsCallMessage({ url, video }, strings, isGerm) {
  const title = video
    ? tr(strings, "teams_call_video_title", isGerm ? "Teams-Videoanruf" : "Teams video call")
    : tr(strings, "teams_call_audio_title", isGerm ? "Teams-Anruf" : "Teams call");
  const join = tr(strings, "teams_call_join", isGerm ? "Jetzt beitreten" : "Join now");
  return `${video ? "🎥" : "📞"} **${title}** · [${join}](${url})`;
}

/** Chat list preview of a call message: "📞 Teams call" instead of the Markdown and the link. */
export function teamsCallPreview(text, strings, isGerm) {
  const call = teamsCallOf(text);
  if (!call || call.kind === "meeting") return null;
  return call.kind === "video"
    ? `🎥 ${tr(strings, "teams_call_video_title", isGerm ? "Teams-Videoanruf" : "Teams video call")}`
    : `📞 ${tr(strings, "teams_call_audio_title", isGerm ? "Teams-Anruf" : "Teams call")}`;
}
